import { Component, ViewEncapsulation } from '@angular/core';
import { Testimonial } from '../../models/testimonials/testimonials.model';
import { CommunicationService } from '../../shared/services/communication.service';

import { ApiService } from '../../shared/services/api.service';
import { ListBase } from '../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-testimonial-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html',
  encapsulation: ViewEncapsulation.None
})
export class TestimonialListComponent extends ListBase<Testimonial> {

  public url = 'testimonials';
  public routePrefix = 'testimonials';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }

}
